import { render, staticRenderFns } from "./FaqInfo.vue?vue&type=template&id=0f931840&scoped=true"
import script from "./FaqInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FaqInfo.vue?vue&type=style&index=0&id=0f931840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f931840",
  null
  
)

export default component.exports